import _ from 'lodash';

function PlayerDetailCtrl($rootScope, $scope, $element, $state, $stateParams, $timeout, $interval, toastr, ChartGeneratorService, PlayerService, UserService, AppContextService, AnalysisService, EventAnalysisService, PlanService) {
  'ngInject';


  // ViewModel
  const vm = this;

  vm.appContext = AppContextService.context;


  vm.appContext.selected = vm.appContext.players.all[_.findIndex(vm.appContext.players.all, {
    user_id: Number($stateParams.user_id)
  })];
  // vm.appContext.selected = '';

  // 선수 버전으로 로그인한 경우 로그인한 사용자로 설정
  if (!$stateParams.type_code || $stateParams.type_code !== 'team') {
    vm.appContext.selected = vm.appContext.user;
  }




  var data = {
    mode: 'recent'
  }

  // if (mode == 'user') {
  //   data.from = vm.startDate.replace(/./g, '');
  //   data.to = vm.endDate.replace(/./g, '');
  // }


  vm.appContext.playerTotalInfo = null;

  // 조직관리에서 선수를 클릭해서 넘어온 경우
  if ($stateParams.from === 'member') {
    vm.appContext.selectedPlayerInfo = null;
  }


  data.user_id = $stateParams.user_id;
  
  // 임시 - headcoach@kfa.or.kr 으로 로그인한 경우
  if (vm.appContext.user.user_id == '2391' && $state.current.name === 'Service.playerDetail') {
    vm.appContext.role2 = 'player';
  } else if (vm.appContext.user.user_id == '2391') {
    vm.appContext.role2 = 'coaching_staff';
  }
  


  vm.openStatAnalysis = function() {
    window.open('http://sgsmanager.com/lab/stat-analysis/');
  };

  // AI 예측 데이터 조회 시작
  vm.topTabNames = ['동작 분석', '생체 분석', '전술 분석', '승률 예측', '득점 예측', '실점 예측', '부상 예측'];
  vm.topTabs = {};
  _.forEach(vm.topTabNames, function(item, i) {
    vm.topTabs[item] = {
      selected: (i === 0 ? true : false)
    };
  });
  vm.selectTopTab = function(item) {
    _.forEach(vm.topTabs, function(value, key) {
      vm.topTabs[key].selected = false;
    });
    vm.topTabs[item].selected = true;

    if (item === '생체 분석') {
      vm.generateAnalysisChartBio();
    } else if (item === '전술 분석') {
      vm.generateAnalysisChartStrategy();
    } else if (item === '승률 예측') {
      vm.generateAnalysisChartStrategy2();
    }
  };

  vm.categories = {
    'device': [
      {
        title: '디바이스',
        items: [
          {
            name: '디바이스',
            title: true,
            selected: true
          },
          {
            name: '워킹',
            title: false,
            selected: false
          },
          {
            name: '스프린트',
            title: false,
            selected: false
          },
          {
            name: '러닝',
            title: false,
            selected: false
          },
          {
            name: 'speed',
            title: false,
            selected: false
          },
          {
            name: 'Street',
            title: false,
            selected: false
          },
          {
            name: 'acceleration',
            title: false,
            selected: false
          }
        ]
      },
    ],
    'movement': [
      {
        title: '동작',
        items: [
          {
            name: '동작',
            title: true,
            selected: true
          },
          {
            name: '워킹',
            title: false,
            selected: false
          },
          {
            name: '스프린트',
            title: false,
            selected: false
          },
          {
            name: '러닝',
            title: false,
            selected: false
          },
          {
            name: '점프',
            title: false,
            selected: false
          },
          {
            name: '턴',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '트래핑',
        items: [
          {
            name: '트래핑',
            title: true,
            selected: true
          },
          {
            name: '땅볼',
            title: false,
            selected: false
          },
          {
            name: '가슴',
            title: false,
            selected: false
          },
          {
            name: '허벅지',
            title: false,
            selected: false
          },
          {
            name: '이동',
            title: false,
            selected: false
          },
          {
            name: '공중볼',
            title: false,
            selected: false
          },
          {
            name: '턴',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '드리블',
        items: [
          {
            name: '드리블',
            title: true,
            selected: true
          },
          {
            name: '볼터치',
            title: false,
            selected: false
          },
          {
            name: '직진',
            title: false,
            selected: false
          },
          {
            name: '방향전환',
            title: false,
            selected: false
          },
          {
            name: '이동',
            title: false,
            selected: false
          },
          {
            name: '페인팅',
            title: false,
            selected: false
          },
          {
            name: '팬텀',
            title: false,
            selected: false
          },
          {
            name: '크루이프턴',
            title: false,
            selected: false
          },
          {
            name: '마르세유턴',
            title: false,
            selected: false
          },
          {
            name: '스텝오버',
            title: false,
            selected: false
          },
          {
            name: '플리플랩',
            title: false,
            selected: false
          },
          {
            name: '맥기디스핀',
            title: false,
            selected: false
          },
          {
            name: '스쿱턴',
            title: false,
            selected: false
          },
          {
            name: '포커스포커스',
            title: false,
            selected: false
          },
          {
            name: '사포',
            title: false,
            selected: false
          },
          {
            name: '돌파',
            title: false,
            selected: false
          },
          {
            name: '돌파허용',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '패스',
        items: [
          {
            name: '패스',
            title: true,
            selected: true
          },
          {
            name: '논스톱',
            title: false,
            selected: false
          },
          {
            name: '원터치',
            title: false,
            selected: false
          },
          {
            name: '스루',
            title: false,
            selected: false
          },
          {
            name: '2V1',
            title: false,
            selected: false
          },
          {
            name: '3자',
            title: false,
            selected: false
          },
          {
            name: '킬',
            title: false,
            selected: false
          },
          {
            name: '침투',
            title: false,
            selected: false
          },
          {
            name: '헤딩',
            title: false,
            selected: false
          },
          {
            name: '피드',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '슈팅',
        items: [
          {
            name: '슈팅',
            title: true,
            selected: true
          },
          {
            name: '원터치',
            title: false,
            selected: false
          },
          {
            name: '발리',
            title: false,
            selected: false
          },
          {
            name: '오버헤드',
            title: false,
            selected: false
          },
          {
            name: '헤딩',
            title: false,
            selected: false
          },
          {
            name: '칩샷',
            title: false,
            selected: false
          },
          {
            name: '위협',
            title: false,
            selected: false
          },
          {
            name: '유효',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '킥',
        items: [
          {
            name: '킥',
            title: true,
            selected: true
          },
          {
            name: '롱',
            title: false,
            selected: false
          },
          {
            name: '짧은',
            title: false,
            selected: false
          },
          {
            name: '다이렉트',
            title: false,
            selected: false
          },
          {
            name: '파넨카',
            title: false,
            selected: false
          },
          {
            name: '드롭',
            title: false,
            selected: false
          },
          {
            name: '라보나',
            title: false,
            selected: false
          },
          {
            name: '스핀',
            title: false,
            selected: false
          },
          {
            name: '바이시클',
            title: false,
            selected: false
          },
          {
            name: '힐',
            title: false,
            selected: false
          }  
        ]
      },
      {
        title: '크로싱',
        items: [
          {
            name: '크로싱',
            title: true,
            selected: true
          },
          {
            name: '얼리',
            title: false,
            selected: false
          },
          {
            name: '레이트',
            title: false,
            selected: false
          },
          {
            name: '컷백',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '태클',
        items: [
          {
            name: '태클',
            title: true,
            selected: true
          },
          {
            name: '포크',
            title: false,
            selected: false
          },
          {
            name: '슬라이딩',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: 'GK',
        items: [
          {
            name: 'GK',
            title: true,
            selected: true
          },
          {
            name: '캐칭',
            title: false,
            selected: false
          },
          {
            name: '세이빙',
            title: false,
            selected: false
          },
          {
            name: '일대일',
            title: false,
            selected: false
          },
          {
            name: '슈퍼세이브',
            title: false,
            selected: false
          },
          {
            name: '실책',
            title: false,
            selected: false
          }
        ]
      }
    ],
    'bio': [
      {
        title: '컨디션',
        items: [
          {
            name: '컨디션',
            title: true,
            selected: true
          },
          {
            name: '심박수',
            title: false,
            selected: false
          },
          {
            name: '체온',
            title: false,
            selected: false
          },
          {
            name: '산소포화도',
            title: false,
            selected: false
          },
          {
            name: '칼로리',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션2',
        items: [
          {
            name: '컨디션2',
            title: true,
            selected: true
          },
          {
            name: '젖산',
            title: false,
            selected: false
          },
          {
            name: '폐활량',
            title: false,
            selected: false
          },
          {
            name: '체중',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션3',
        items: [
          {
            name: '컨디션3',
            title: true,
            selected: true
          },
          {
            name: '체수분',
            title: false,
            selected: false
          },
          {
            name: '체지방',
            title: false,
            selected: false
          },
          {
            name: '골격근',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '컨디션4',
        items: [
          {
            name: '컨디션4',
            title: true,
            selected: true
          },
          {
            name: '혈당',
            title: false,
            selected: false
          },
          {
            name: '혈압',
            title: false,
            selected: false
          },
          {
            name: '단백질',
            title: false,
            selected: false
          }
        ]
      }
    ],
    'location': [
      {
        title: '세트피스',
        items: [
          {
            name: '세트피스',
            title: true,
            selected: true
          },
          {
            name: '골킥',
            title: false,
            selected: false
          },
          {
            name: '스로잉',
            title: false,
            selected: false
          },
          {
            name: '코너킥',
            title: false,
            selected: false
          },
          {
            name: '프리킥',
            title: false,
            selected: false
          },
          {
            name: '페널티킥',
            title: false,
            selected: false
          }
        ]
      },
      {
        title: '수비',
        items: [
          {
            name: '수비',
            title: true,
            selected: true
          },
          {
            name: '가로채기',
            title: false,
            selected: false
          },
          {
            name: '클리어',
            title: false,
            selected: false
          },
          {
            name: '그라운드경합',
            title: false,
            selected: false
          },
          {
            name: '공중볼경합',
            title: false,
            selected: false
          },
          {
            name: '압박',
            title: false,
            selected: false
          },
          {
            name: '세컨볼',
            title: false,
            selected: false
          },
          {
            name: '그라운드차단',
            title: false,
            selected: false
          },
          {
            name: '공중볼차단',
            title: false,
            selected: false
          },
          {
            name: '패스차단',
            title: false,
            selected: false
          }
        ]
      }
    ],
    'location2': [
      {
        title: '경기결과',
        items: [
          {
            name: '경기결과',
            title: true,
            selected: true
          },
          {
            name: '자책골',
            title: false,
            selected: false
          },
          {
            name: '파울',
            title: false,
            selected: false
          },
          {
            name: '경고',
            title: false,
            selected: false
          },
          {
            name: '퇴장',
            title: false,
            selected: false
          },
          {
            name: '오프사이드',
            title: false,
            selected: false
          }
        ]
      }
    ]
  };






  var user_id = [data.user_id];
  var movementNames = ['워킹', '러닝', '점프', '턴', '스프린트'];
  var analysisDataOptions = {
    // limit: 1000,  // 최근 1000건
    from: '2020-01-01',
    user_ids: JSON.stringify(user_id)
  };

  // vm.categories.movement - 퍼포먼스

  _.forEach(vm.categories.movement, function(category) {
    category.showPerformance = true;
    category.showLocation = false;
  });

  _.forEach(vm.categories.bio, function(category) {
    category.showBio = true;
    category.showLocation = false;
  });

  _.forEach(vm.categories.location, function(category) {
    category.showStrategy = true;
    category.showLocation = false;
  });

  _.forEach(vm.categories.location2, function(category) {
    category.showStrategy2 = true;
    category.showLocation = false;
  });

  // 동작 분석
  vm.generateAnalysisChartPerformance = function (update) {
    _.forEach(vm.categories.movement, function(category) {
      _.forEach(category.items, function(item) {
        item.left = 0;
        item.right = 0;
        item.inside = 0;
        item.outside = 0;
        item.instep = 0;
        item.sole = 0;
        item.stride = 0;
        item.value = 0;

        item.data = [];
      });
    });

    AnalysisService.getPlayersPredictionData(analysisDataOptions).then(function(res2) {
      var analysisData = res2.data,
        dataKey;
  
      _.forEach(analysisData, function(analysisItem) {
        _.forEach(vm.categories.movement, function(category) {
          if (category.title === '동작') {  // '워킹', '러닝', '점프', '턴', '스프린트'
            dataKey = 'type7';
          } else {
            dataKey = 'type4';
          }
  
          if ((analysisItem[dataKey] && analysisItem[dataKey].match(category.title)) || (category.title === '동작' && (movementNames.indexOf(analysisItem[dataKey]) > -1))) {
            _.forEach(category.items, function(item) {
              if (item.title) {
                item.value++;
  
                if (analysisItem.type3 === 'L') {
                  item.left++;
                } else if (analysisItem.type3 === 'R') {
                  item.right++;
                }
  
                if (analysisItem.type2 === 'Inside') {
                  item.inside++;
                } else if (analysisItem.type2 === 'Outside') {
                  item.outside++;
                } else if (analysisItem.type2 === 'Instep') {
                  item.instep++;
                } else if (analysisItem.type2 === 'Sole') {
                  item.sole++;
                }
              } else {
                if (analysisItem[dataKey] && analysisItem[dataKey].match(item.name)) {
                  item.value++;
    
                  if (analysisItem.type3 === 'L') {
                    item.left++;
                  } else if (analysisItem.type3 === 'R') {
                    item.right++;
                  }
    
                  if (analysisItem.type2 === 'Inside') {
                    item.inside++;
                  } else if (analysisItem.type2 === 'Outside') {
                    item.outside++;
                  } else if (analysisItem.type2 === 'Instep') {
                    item.instep++;
                  } else if (analysisItem.type2 === 'Sole') {
                    item.sole++;
                  }
  
                  item.detail = {
                    left: item.left,
                    right: item.right,
                    inside: item.inside,
                    outside: item.outside,
                    instep: item.instep,
                    sole: item.sole
                  };
  
                  if (typeof item.data === 'undefined') {
                    item.data = [];
                  }
                  var obj = _.find(item.data, function(dataItem) {
                    return dataItem.datetime.substr(0, 16) === analysisItem.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj) {
                    obj.value = obj.value + 1;
                  } else {
                    item.data.push({
                      datetime: analysisItem.datetime.substr(0, 16),
                      value: 1
                    });
                  }
                }
              }
            });
          }
        });
      });
  
      // 차트 생성
      _.forEach(vm.categories['movement'], function(category) {
        (function(category) {
          $timeout(function() {
            if (update) {
              // 전체 차트 생성
              if (!$('#' + category.title + '-chart2').is(':visible')) {
                vm.generateVariableRadiusChart(category, true);
                vm.generateMainBarChart(category);
                vm.generateScatterPlot(category, false, update);
              }
              // 개별 차트 생성
              else {
                if (category.title === '동작') {
                  return;
                }
  
                var name = $('#' + category.title + '-chart2').closest('.chart-container').find('.w3-btn.w3-pink').find('.ng-binding').text();
                _.forEach(category.items, function(obj) {
                  if (name === obj.name) {
                    obj.selected = true;
                  } else {
                    obj.selected = false;
                  }
            
                  vm.clearChart(category.title);
            
                  vm.chartData[category.title].showMain = false;
                  vm.generateBarChart(category, obj);
                  vm.generateScatterPlot(category, obj, update);
                });
              }
            } else {
              vm.generateVariableRadiusChart(category);
              vm.generateMainBarChart(category);
              vm.generateScatterPlot(category, false, update);
            }
          }, update ? 0 : 1000);
        })(category);
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 생체 분석
  vm.generateAnalysisChartBio = function (update) {
    _.forEach(vm.categories.bio, function(category) {
      _.forEach(category.items, function(item) {
        item.left = 0;
        item.right = 0;
        item.inside = 0;
        item.outside = 0;
        item.instep = 0;
        item.sole = 0;
        item.stride = 0;
        item.value = 0;

        item.data = [];
      });
    });

    AnalysisService.getPlayersPredictionData(analysisDataOptions).then(function(res2) {
      var analysisData = res2.data,
        dataKey;
  
      _.forEach(analysisData, function(analysisItem) {
        _.forEach(vm.categories.bio, function(category) {
          if (category.title === '동작') {  // '워킹', '러닝', '점프', '턴', '스프린트'
            dataKey = 'type7';
          } else {
            dataKey = 'type4';
          }
  
          if ((analysisItem[dataKey] && analysisItem[dataKey].match(category.title)) || (category.title === '동작' && (movementNames.indexOf(analysisItem[dataKey]) > -1))) {
            _.forEach(category.items, function(item) {
              if (item.title) {
                item.value++;
  
                if (analysisItem.type3 === 'L') {
                  item.left++;
                } else if (analysisItem.type3 === 'R') {
                  item.right++;
                }
  
                if (analysisItem.type2 === 'Inside') {
                  item.inside++;
                } else if (analysisItem.type2 === 'Outside') {
                  item.outside++;
                } else if (analysisItem.type2 === 'Instep') {
                  item.instep++;
                } else if (analysisItem.type2 === 'Sole') {
                  item.sole++;
                }
              } else {
                if (analysisItem[dataKey] && analysisItem[dataKey].match(item.name)) {
                  item.value++;
    
                  if (analysisItem.type3 === 'L') {
                    item.left++;
                  } else if (analysisItem.type3 === 'R') {
                    item.right++;
                  }
    
                  if (analysisItem.type2 === 'Inside') {
                    item.inside++;
                  } else if (analysisItem.type2 === 'Outside') {
                    item.outside++;
                  } else if (analysisItem.type2 === 'Instep') {
                    item.instep++;
                  } else if (analysisItem.type2 === 'Sole') {
                    item.sole++;
                  }
  
                  item.detail = {
                    left: item.left,
                    right: item.right,
                    inside: item.inside,
                    outside: item.outside,
                    instep: item.instep,
                    sole: item.sole
                  };
  
                  if (typeof item.data === 'undefined') {
                    item.data = [];
                  }
                  var obj = _.find(item.data, function(dataItem) {
                    return dataItem.datetime.substr(0, 16) === analysisItem.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj) {
                    obj.value = obj.value + 1;
                  } else {
                    item.data.push({
                      datetime: analysisItem.datetime.substr(0, 16),
                      value: 1
                    });
                  }
                }
              }
            });
          }
        });
      });
  
      // 차트 생성
      _.forEach(vm.categories['bio'], function(category) {
        (function(category) {
          $timeout(function() {
            // console.log(category);

            vm.generateActivityChart(category, update);
            vm.generateActivityText(category, update);
            vm.generateScatterPlot(category, false, update);
          }, 1000);
        })(category);
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 전술 분석
  vm.generateAnalysisChartStrategy = function (update) {
    _.forEach(vm.categories.location, function(category) {
      _.forEach(category.items, function(item) {
        item.left = 0;
        item.right = 0;
        item.inside = 0;
        item.outside = 0;
        item.instep = 0;
        item.sole = 0;
        item.stride = 0;
        item.value = 0;

        item.data = [];
      });
    });

    AnalysisService.getPlayersPredictionData(analysisDataOptions).then(function(res2) {
      var analysisData = res2.data,
        dataKey;
  
      _.forEach(analysisData, function(analysisItem) {
        _.forEach(vm.categories.location, function(category) {
          if (category.title === '동작') {  // '워킹', '러닝', '점프', '턴', '스프린트'
            dataKey = 'type7';
          } else {
            dataKey = 'type4';
          }
  
          if ((analysisItem[dataKey] && analysisItem[dataKey].match(category.title)) || (category.title === '동작' && (movementNames.indexOf(analysisItem[dataKey]) > -1))) {
            _.forEach(category.items, function(item) {
              if (item.title) {
                item.value++;
  
                if (analysisItem.type3 === 'L') {
                  item.left++;
                } else if (analysisItem.type3 === 'R') {
                  item.right++;
                }
  
                if (analysisItem.type2 === 'Inside') {
                  item.inside++;
                } else if (analysisItem.type2 === 'Outside') {
                  item.outside++;
                } else if (analysisItem.type2 === 'Instep') {
                  item.instep++;
                } else if (analysisItem.type2 === 'Sole') {
                  item.sole++;
                }
              } else {
                if (analysisItem[dataKey] && analysisItem[dataKey].match(item.name)) {
                  item.value++;
    
                  if (analysisItem.type3 === 'L') {
                    item.left++;
                  } else if (analysisItem.type3 === 'R') {
                    item.right++;
                  }
    
                  if (analysisItem.type2 === 'Inside') {
                    item.inside++;
                  } else if (analysisItem.type2 === 'Outside') {
                    item.outside++;
                  } else if (analysisItem.type2 === 'Instep') {
                    item.instep++;
                  } else if (analysisItem.type2 === 'Sole') {
                    item.sole++;
                  }
  
                  item.detail = {
                    left: item.left,
                    right: item.right,
                    inside: item.inside,
                    outside: item.outside,
                    instep: item.instep,
                    sole: item.sole
                  };
  
                  if (typeof item.data === 'undefined') {
                    item.data = [];
                  }
                  var obj = _.find(item.data, function(dataItem) {
                    return dataItem.datetime.substr(0, 16) === analysisItem.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj) {
                    obj.value = obj.value + 1;
                  } else {
                    item.data.push({
                      datetime: analysisItem.datetime.substr(0, 16),
                      value: 1
                    });
                  }
                }
              }
            });
          }
        });
      });
  
      // 차트 생성
      _.forEach(vm.categories['location'], function(category) {
        (function(category) {
          $timeout(function() {
            if (update) {
              // 전체 차트 생성
              if (!$('#' + category.title + '-chart2').is(':visible')) {
                vm.generateVariableRadiusChart(category, true);
                vm.generateMainBarChart(category);
                vm.generateScatterPlot(category, false, update);
              }
              // 개별 차트 생성
              else {
                if (category.title === '동작') {
                  return;
                }
  
                var name = $('#' + category.title + '-chart2').closest('.chart-container').find('.w3-btn.w3-pink').find('.ng-binding').text();
                _.forEach(category.items, function(obj) {
                  if (name === obj.name) {
                    obj.selected = true;
                  } else {
                    obj.selected = false;
                  }
            
                  vm.clearChart(category.title);
            
                  vm.chartData[category.title].showMain = false;
                  vm.generateBarChart(category, obj);
                  vm.generateScatterPlot(category, obj, update);
                });
              }
            } else {
              vm.generateVariableRadiusChart(category);
              vm.generateMainBarChart(category);
              vm.generateScatterPlot(category, false, update);
            }
          }, update ? 0 : 1000);
        })(category);
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 승률 예측
  vm.generateAnalysisChartStrategy2 = function (update) {
    _.forEach(vm.categories.location2, function(category) {
      _.forEach(category.items, function(item) {
        item.left = 0;
        item.right = 0;
        item.inside = 0;
        item.outside = 0;
        item.instep = 0;
        item.sole = 0;
        item.stride = 0;
        item.value = 0;

        item.data = [];
      });
    });

    AnalysisService.getPlayersPredictionData(analysisDataOptions).then(function(res2) {
      var analysisData = res2.data,
        dataKey;
  
      _.forEach(analysisData, function(analysisItem) {
        _.forEach(vm.categories.location2, function(category) {
          if (category.title === '동작') {  // '워킹', '러닝', '점프', '턴', '스프린트'
            dataKey = 'type7';
          } else {
            dataKey = 'type4';
          }
  
          if ((analysisItem[dataKey] && analysisItem[dataKey].match(category.title)) || (category.title === '동작' && (movementNames.indexOf(analysisItem[dataKey]) > -1))) {
            _.forEach(category.items, function(item) {
              if (item.title) {
                item.value++;
  
                if (analysisItem.type3 === 'L') {
                  item.left++;
                } else if (analysisItem.type3 === 'R') {
                  item.right++;
                }
  
                if (analysisItem.type2 === 'Inside') {
                  item.inside++;
                } else if (analysisItem.type2 === 'Outside') {
                  item.outside++;
                } else if (analysisItem.type2 === 'Instep') {
                  item.instep++;
                } else if (analysisItem.type2 === 'Sole') {
                  item.sole++;
                }
              } else {
                if (analysisItem[dataKey] && analysisItem[dataKey].match(item.name)) {
                  item.value++;
    
                  if (analysisItem.type3 === 'L') {
                    item.left++;
                  } else if (analysisItem.type3 === 'R') {
                    item.right++;
                  }
    
                  if (analysisItem.type2 === 'Inside') {
                    item.inside++;
                  } else if (analysisItem.type2 === 'Outside') {
                    item.outside++;
                  } else if (analysisItem.type2 === 'Instep') {
                    item.instep++;
                  } else if (analysisItem.type2 === 'Sole') {
                    item.sole++;
                  }
  
                  item.detail = {
                    left: item.left,
                    right: item.right,
                    inside: item.inside,
                    outside: item.outside,
                    instep: item.instep,
                    sole: item.sole
                  };
  
                  if (typeof item.data === 'undefined') {
                    item.data = [];
                  }
                  var obj = _.find(item.data, function(dataItem) {
                    return dataItem.datetime.substr(0, 16) === analysisItem.datetime.substr(0, 16);  // 날짜와 시간, 분이 같은 경우
                  });
                  if (obj) {
                    obj.value = obj.value + 1;
                  } else {
                    item.data.push({
                      datetime: analysisItem.datetime.substr(0, 16),
                      value: 1
                    });
                  }
                }
              }
            });
          }
        });
      });
  
      // 차트 생성
      _.forEach(vm.categories['location2'], function(category) {
        (function(category) {
          $timeout(function() {
            if (update) {
              // 전체 차트 생성
              if (!$('#' + category.title + '-chart2').is(':visible')) {
                vm.generateVariableRadiusChart(category, true);
                vm.generateMainBarChart(category);
                vm.generateScatterPlot(category, false, update);
              }
              // 개별 차트 생성
              else {
                if (category.title === '동작') {
                  return;
                }
  
                var name = $('#' + category.title + '-chart2').closest('.chart-container').find('.w3-btn.w3-pink').find('.ng-binding').text();
                _.forEach(category.items, function(obj) {
                  if (name === obj.name) {
                    obj.selected = true;
                  } else {
                    obj.selected = false;
                  }
            
                  vm.clearChart(category.title);
            
                  vm.chartData[category.title].showMain = false;
                  vm.generateBarChart(category, obj);
                  vm.generateScatterPlot(category, obj, update);
                });
              }
            } else {
              vm.generateVariableRadiusChart(category);
              vm.generateMainBarChart(category);
              vm.generateScatterPlot(category, false, update);
            }
          }, update ? 0 : 1000);
        })(category);
      });
    }).catch(function(err) {
      console.log(err);
    });
  }



  if (vm.appContext.playerChartTimer) {
    $interval.cancel(vm.appContext.playerChartTimer);
  }

  // 차트 생성, 실시간 데이터 조회
  if (data.user_id == '32') {
    vm.generateAnalysisChartPerformance();
    vm.appContext.playerChartTimer = $interval(function() {
      vm.generateAnalysisChartPerformance(true);

      // 심박수 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value1'
        },
        success: function(data) {
          $('#item40value1').html(data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // 산소포화도 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value2'
        },
        success: function(data) {
          $('#item40value2').html(data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // 체온 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value3'
        },
        success: function(data) {
          $('#item40value3').html(data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // speed 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value6'
        },
        success: function(data) {
          $('#item40value6').html(data[0].value);
          $scope.vm.setVelocityInfo('current', '', data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // acceleration 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value8'
        },
        success: function(data) {
          $('#item40value8').html(data[0].value);
          $scope.vm.setAccelerationInfo('current', '', data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // Street 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'item40value9'
        },
        success: function(data) {
          $('#item40value9').html(data[0].value);
          $scope.vm.setDistanceInfo('current', '', data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });

      // stride 조회
      $.ajax({
        url: 'http://eptsdev.codns.com:7724/manager/get_device_distance_data',
        type: 'GET',
        data: {
          type: 'deviceStrideValue'
        },
        success: function(data) {
          $('#device-stride-value').html(data[0].value);
        },
        error: function(err) {
          console.log(err);
        }
      });
    }, 2000);
  }
  



  // 위치 히트맵
  vm.generateHeatmap = function(category) {
    var chartContainer = $('#' + category + '-container'),
      heatmap = $('#' + category + '-heatmap');

    heatmap.find('canvas').remove();

    heatmap.css({
      width: chartContainer.width() + 'px',
      height: '170px'
    });

    // minimal heatmap instance configuration
    var heatmapInstance = h337.create({
      // only container is required, the rest will be defaults
      container: heatmap[0]
    });

    // now generate some random data
    var points = [];
    var max = 0;
    var width = chartContainer.width();
    var height = 170;
    var len = 70;

    while (len--) {
      var val = Math.floor(Math.random()*100);
      max = Math.max(max, val);
      var point = {
        x: Math.floor(Math.random()*width),
        y: Math.floor(Math.random()*height),
        value: val
      };
      points.push(point);
    }
    // heatmap data format
    var data = {
      max: max,
      data: points
    };
    // if you have a set of datapoints always use setData instead of addData
    // for data initialization
    heatmapInstance.setData(data);

    heatmap.css({
      position: 'absolute'
    });
  };





  vm.chartData = {};

  // 동작 분석
  _.forEach(vm.categories.movement, function(category) {
    vm.chartData[category.title] = {};
  });

  vm.categorySelect = function(category, item) {
    if (category.title.match('컨디션')) {
      _.forEach(category.items, function(obj) {
        if (item.name === obj.name) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
  
        vm.clearChart(category.title);
  
        // 전체 차트 생성
        if (item.title) {
          vm.generateActivityChart(category);
          vm.generateActivityText(category);
          vm.generateScatterPlot(category, false, true);
        }
        // 개별 차트 생성
        else {
          vm.chartData[category.title].showMain = false;
          // vm.generateBioBarChart(category, item);
          vm.generateActivityChart2(category, item);
          vm.generateActivityText2(category, item);
          vm.generateScatterPlot(category, item);
        }
      });
    } else {
      _.forEach(category.items, function(obj) {
        if (item.name === obj.name) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
  
        vm.clearChart(category.title);
  
        // 전체 차트 생성
        if (item.title) {
          vm.generateVariableRadiusChart(category);
          vm.generateMainBarChart(category);
          vm.generateScatterPlot(category, false);
        }
        // 개별 차트 생성
        else {
          vm.chartData[category.title].showMain = false;
          vm.generateBarChart(category, item);
          vm.generateScatterPlot(category, item);
        }
      });
    }
  };

  vm.clearChart = function(title) {
    let targetId = '#' + title + '-chart';
    $(targetId).html('');
    let targetId2 = '#' + title + '-chart2';
    $(targetId2).html('');
    let targetId3 = '#' + title + '-chart3';
    $(targetId3).html('');
  };

  vm.generateBarChart = function(category, item) {
    // 값 표시
    if (category.title === '동작') {
      let containerId = category.title + '-chart2';

      let html;

      let count = item.value;

      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">number</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:16px;">' + count + '</span> set</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">acceleration</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">speed</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">Street</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> min</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> kcal</span></span>';
      html += '<span style="display:block; margin-top:5px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">stride</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:16px;">0</span> cm</span></span>';
      $('#' + containerId).html(html);
    }
    // 바차트
    else {
      let left = item.left;
      let right = item.right;
      let inside = item.inside;
      let outside = item.outside;
      let instep = item.instep;
      let sole = item.sole;
      let stride = item.stride;
      let value = item.value;
      stride = (value === 0) ? 0 : stride / value;
      
      let data = {
        name: item.name,
        left: left,
        right: right,
        inside: inside,
        outside: outside,
        instep: instep,
        sole: sole,
        stride: stride
      };
      vm.playerSkillData = data;
      let targetId = '#' + category.title + '-chart2';

      $(targetId).html('');

      let performanceTitles = ['활동량', '동작'];

      let dataset;
      if (performanceTitles.indexOf(category.title) > -1) {
        dataset = [{
          data: [{
              title: 'number',
              count: 0
            },{
              title: 'acceleration',
              count: 0
            } ,{
              title: 'speed',
              count: 0
            },
            {
              title: 'Street',
              count: 0
            },
            {
              title: '시간',
              count: 0
            },
            {
              title: '칼로리',
              count: 0
            },{
              title: 'stride',
              count: 0
            }
          ]}
        ];
      } else {
        dataset = [{
          data: [{
              title: 'Left foot',
              count: left
            },
            {
              title: 'Right foot',
              count: right
            },
            {
              title: 'Inside',
              count: inside
            },
            {
              title: 'Outside',
              count: outside
            },{
              title: 'Instep',
              count: instep
            },{
              title: 'Sole',
              count: sole
            },{
              title: 'stride',
              count: stride
            }
          ]}
        ];  
      }
      console.log('dataset', dataset);

      vm.chartData[category.title].detail = data;

      ChartGeneratorService.createStackedBarChartHorizAnalysis(targetId, dataset);
    }
  };

  vm.generateScatterPlot = function(category, item, update) {
    // console.log('scatter', vm.appContext.deviceData, category);

    let options = {
      containerId: category.title + '-scatter'
    };

    ChartGeneratorService.createScatterPlotAnalysis(options, category, item, update);
  };

  vm.generateVariableRadiusChart = function(category, update) {
    let options = {
      containerId: category.title + '-chart',
      width: 200,
      height: 150
    };

    let data = {
      showMain: true
    };
    vm.chartData[category.title] = data;

    ChartGeneratorService.generateVariableRadiusChart(options, category, update);
  };

  vm.generateMainBarChart = function(category) {
    // 값 표시
    if (category.title === '동작') {
      let containerId = category.title + '-chart3';

      let html;

      let count = 0;
      _.forEach(category.items, function(item) {
        if (item.name !== '동작') {
          count += item.value;
        }
      });

      if (vm.appContext.isIOS) {
        html = '<div style="overflow:hidden;"><div style="width:100px; float:right;><div style="text-align:left;">';
        html += '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">number</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:16px;">' + count + '</span> set</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">acceleration</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">speed</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">Street</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:16px;">0</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> min</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> kcal</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">stride</span><br><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:16px;">0</span> cm</span></span>';
        html += '</div></div></div>';
      } else {
        html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">number</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span style="font-weight:normal; font-size:16px;">' + count + '</span> set</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">acceleration</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value8" style="font-weight:normal; font-size:16px;">' + ($('#item40value8').html() || 0)  + '</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">speed</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value6" style="font-weight:normal; font-size:16px;">' + ($('#item40value6').html() || 0)  + '</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">Street</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value9" style="font-weight:normal; font-size:16px;">' + ($('#item40value9').html() || 0)  + '</span> km</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">시간</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> min</span></span>';
        // html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">칼로리</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="" style="font-weight:normal; font-size:16px;">0</span> kcal</span></span>';
        html += '<span style="display:block; margin-top:1px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">stride</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="device-stride-value" style="font-weight:normal; font-size:16px;">0</span> cm</span></span>';
      }
      $('#' + containerId).html(html);
    }
    // 바차트
    else {
      let item = {
        name: '전체'
      };
  
      let total = {
        left: 0,
        right: 0,
        inside: 0,
        outside: 0,
        instep: 0,
        sole: 0,
        stride: 0,
        value: 0
      };
  
      _.forEach(category.items, function(item) {
        total.left += item.left;
        total.right += item.right;
        total.inside += item.inside;
        total.outside += item.outside;
        total.instep += item.instep;
        total.sole += item.sole;
        total.stride += item.stride;
        total.value += item.value;
      });
  
      // if (total.left === 0 && total.right === 0 && total.inside === 0 && total.outside === 0 && total.instep === 0) {
      //   return;
      // }
  
      let left = total.left;
      let right = total.right;
      let inside = total.inside;
      let outside = total.outside;
      let instep = total.instep;
      let sole = total.sole;
      let stride = total.stride;
      let value = total.value;
      stride = (value === 0) ? 0 : stride / value;
      console.log(category.items, left, right);
      let data = {
        name: item.name,
        left: left,
        right: right,
        inside: inside,
        outside: outside,
        instep: instep,
        sole: sole,
        stride: stride
      };
      vm.playerSkillData = data;
      let targetId = '#' + category.title + '-chart3';
  
      $(targetId).html('');
  
      let performanceTitles = ['활동량', '동작'];
  
      let dataset;
      if (performanceTitles.indexOf(category.title) > -1) {
        dataset = [{
          data: [{
              title: 'number',
              count: 0
            },{
              title: 'acceleration',
              count: 0
            },{
              title: 'speed',
              count: 0
            },
            {
              title: 'Street',
              count: 0
            },
            {
              title: '시간',
              count: 0
            },
            {
              title: '칼로리',
              count: 0
            },{
              title: 'stride',
              count: 0
            }
          ]}
        ];
      } else {
        dataset = [{
          data: [{
              title: 'Left foot',
              count: left
            },
            {
              title: 'Right foot',
              count: right
            },
            {
              title: 'Inside',
              count: inside
            },
            {
              title: 'Outside',
              count: outside
            },{
              title: 'Instep',
              count: instep
            },{
              title: 'Sole',
              count: sole
            },{
              title: 'stride',
              count: stride
            }
          ]}
        ];  
      }
      // console.log('dataset', dataset);
      ChartGeneratorService.createStackedBarChartHorizAnalysis(targetId, dataset);
    }
  };

  vm.generateActivityChart = function(category, update) {
    if (update) {
      return;
    }

    let options = {
      containerId: category.title + '-chart',
      width: 200,
      height: 136
    };

    let data = {
      showMain: true
    };
    vm.chartData[category.title] = data;

    ChartGeneratorService.generateActivityChart(options, category);
  };

  vm.generateActivityText = function(category, update) {
    if (update) {
      return;
    }

    let containerId = category.title + '-chart3';

    let html;

    if (category.title === '컨디션') {
      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">심박수</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value1" style="font-weight:normal; font-size:16px;">' + ($('#item40value1').html() || 0)  + '</span> bpm</span></span>';
      html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체온</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value3" style="font-weight:normal; font-size:16px;">' + ($('#item40value3').html() || 0)  + '</span> ℃</span></span>';
      html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">산소포화도</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;"><span id="item40value2" style="font-weight:normal; font-size:16px;">' + ($('#item40value2').html() || 0)  + '</span> %</span></span>';
    } else if (category.title === '컨디션2') {
      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">젖산</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 mg/dl</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">폐활량</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 ml</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체중</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 kg</span></span>';
    } else if (category.title === '컨디션3') {
      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체수분</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 l</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">체지방</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 kg</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">골격근</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 km</span></span>';
    } else if (category.title === '컨디션4') {
      html = '<span style="display:block; margin-top:20px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">혈당</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 mg</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">혈압</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 mmHg</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:left; margin-left:20px;"><span style="display:inline-block; width:60px;">단백질</span><span style="margin-left:16px; font-weight:normal; font-size:16px; text-align:left; margin-left:10px;">0 %</span></span>';
    }

    $('#' + containerId).html(html);
  };

  vm.generateActivityChart2 = function(category, item) {
    let options = {
      containerId: category.title + '-chart2',
      width: 200,
      height: 136
    };

    let data = {
      showMain: false
    };
    vm.chartData[category.title] = data;

    ChartGeneratorService.generateActivityChart(options, category, item);
  };

  vm.generateActivityText2 = function(category, item) {
    let containerId = category.title + '-chart4';

    // 심박수 - data40
    // 체온 - data42
    // 산소포화도 - data41

    var unit;
    if (item.name === '심박수') {
      unit = 'bpm';
    } else if (item.name === '체온') {
      unit = '℃';
    } else if (item.name === '산소포화도') {
      unit = '%';
    } else if (item.name === '젖산') {
      unit = 'mg/dl';
    } else if (item.name === '폐활량') {
      unit = 'ml';
    } else if (item.name === '체중') {
      unit = 'kg';
    } else if (item.name === '체수분') {
      unit = 'l';
    } else if (item.name === '체지방') {
      unit = 'kg';
    } else if (item.name === '골격근') {
      unit = 'kg';
    } else if (item.name === '혈당') {
      unit = 'mg';
    } else if (item.name === '혈압') {
      unit = 'mmHg';
    } else if (item.name === '단백질') {
      unit = '%';
    } else if (item.name === '칼로리') {
      unit = 'kcal';
    }

    let html = '<span style="display:block; margin-top:10px; color:#fff; font-size:16px; text-align:center;">최대<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:center;">안정<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:center;">회복<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';
    html += '<span style="display:block; margin-top:7px; color:#fff; font-size:16px; text-align:center;">위험<span style="margin-left:16px; font-weight:bold; font-size:16px; text-align:center;">0' + unit + '</span></span>';

    $('#' + containerId).html(html);
  };

  /**
   * 득점 예측 선택값 세팅
   */
  let strategyChart1;
  vm.setStrategyChart1 = function (type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryburn = type;
    // let value = vm.playerTotalInfo.calrorie_burned[0][type];
    let value = 0;

    let caloryBurnKeyName = 'caloryburn';
    let targetId = '#player-strategy1-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.caloryburnSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_burned[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (strategyChart1.type == 'liquid') {
        strategyChart1 = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!strategyChart1) {
        strategyChart1 = ChartGeneratorService.updateRadialProgress(targetId);
        strategyChart1.diameter(90).value(chartValue).render();
        strategyChart1['type'] = 'raidal';
      } else {
        strategyChart1.diameter(90).value(chartValue).render();
      }
    } else {
      let max = vm.playerTotalInfo.calrorie_burned[0].max;
      let dataValue;
      if (max == 0) {
        max = 100;
        dataValue = 0;
      } else {
        dataValue = (value / max) * 100;
      }

      if (!strategyChart1 || strategyChart1.type == 'raidal') {
        strategyChart1 = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-burn-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if (!strategyChart1) {
        strategyChart1 = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        strategyChart1['type'] = 'liquid';
      } else {
        strategyChart1.update(Math.round(dataValue));
      }
    }
    let data = {
      title: '득점 예측',
      value: number_format(value),
      unit: '골'
    };
    vm.playerStrategy1Data = data;

    //line chart
    let caloryBurnColumnData = [caloryBurnKeyName];
    let caloryBurnData = vm.playerTotalInfo.calrorie_burned[0].data;
    for (let i = 0; i < caloryBurnData.length; i++) {
      caloryBurnColumnData.push(caloryBurnData[i].value);
    }

    let caloryBurnType = {};
    caloryBurnType[caloryBurnKeyName] = 'spline';

    let caloryBurnChartOptions = {
      targetId: '#player-strategy1-line-chart',
      padding: chartPadding,
      columnData: caloryBurnColumnData,
      type: caloryBurnType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryBurnOptions = ChartGeneratorService.setLineChartOptions(caloryBurnChartOptions);
    ChartGeneratorService.generateLineChart(caloryBurnOptions);
  }

  /**
   * 실점 예측 선택값 세팅
   */
  let strategyChart2;
  vm.setStrategyChart2 = function (type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryburn = type;
    // let value = vm.playerTotalInfo.calrorie_burned[0][type];
    let value = 0;

    let caloryBurnKeyName = 'caloryburn';
    let targetId = '#player-strategy2-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.caloryburnSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_burned[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (strategyChart2.type == 'liquid') {
        strategyChart2 = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!strategyChart2) {
        strategyChart2 = ChartGeneratorService.updateRadialProgress(targetId);
        strategyChart2.diameter(90).value(chartValue).render();
        strategyChart2['type'] = 'raidal';
      } else {
        strategyChart2.diameter(90).value(chartValue).render();
      }
    } else {
      let max = vm.playerTotalInfo.calrorie_burned[0].max;
      let dataValue;
      if (max == 0) {
        max = 100;
        dataValue = 0;
      } else {
        dataValue = (value / max) * 100;
      }

      if (!strategyChart2 || strategyChart2.type == 'raidal') {
        strategyChart2 = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-burn-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if (!strategyChart2) {
        strategyChart2 = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        strategyChart2['type'] = 'liquid';
      } else {
        strategyChart2.update(Math.round(dataValue));
      }
    }
    let data = {
      title: '실점 예측',
      value: number_format(value),
      unit: '골'
    };
    vm.playerStrategy2Data = data;

    //line chart
    let caloryBurnColumnData = [caloryBurnKeyName];
    let caloryBurnData = vm.playerTotalInfo.calrorie_burned[0].data;
    for (let i = 0; i < caloryBurnData.length; i++) {
      caloryBurnColumnData.push(caloryBurnData[i].value);
    }

    let caloryBurnType = {};
    caloryBurnType[caloryBurnKeyName] = 'spline';

    let caloryBurnChartOptions = {
      targetId: '#player-strategy2-line-chart',
      padding: chartPadding,
      columnData: caloryBurnColumnData,
      type: caloryBurnType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryBurnOptions = ChartGeneratorService.setLineChartOptions(caloryBurnChartOptions);
    ChartGeneratorService.generateLineChart(caloryBurnOptions);
  }
  // AI 예측 데이터 조회 끝



  PlayerService.getPlayerBiometricInfo(data).then(function (res) {

    $timeout(function() {
      vm.appContext.playerTotalInfo = vm.playerTotalInfo;

      // 조직관리에서 선수를 클릭해서 넘어온 경우
      if ($stateParams.from === 'member') {
        UserService.info({
          'user_id': $stateParams.user_id
        }).then(function (res) {
          vm.appContext.selectedPlayerInfo = res.data;
        });
      }
    });


    vm.playerTotalInfo = res.data;

    vm.playerTotalInfo.acceleration = vm.playerTotalInfo.velocity;

    // console.log('vm.playerTotalInfo', vm.playerTotalInfo);
    setMainPagePlayerInfo();
    $scope.$watchGroup(['vm.selectedSkill', 'vm.selectedLocation', 'vm.selectedFoot'], function (newVal, oldVal) {
      vm.setMovementsInfo(newVal);
    });
    vm.playerSkillData = res.data;
    let skillKeyName = 'skill';
    let targetId = '#player-skill-main-chart';

    // $('.loading').hide();

  }, function (err) {
    console.log('getPlayerBiometricInfo err : ', err)
  }).catch(function (error) {
    console.log("An error occured : " + error);
  })



  window['scope'] = $scope;

  const h337 = require('heatmap.js');
  const Flatpickr = require('flatpickr');
  const Korean = require("flatpickr/dist/l10n/ko.js").ko;

  // // ViewModel
  // const vm = this;

  // sidebar 초기화
  $rootScope.$emit('base:sidebarEvent', 'open');


  let number_format = d3.format(',');

  //현재 page명 세팅
  // $scope.$parent.base.pageStatus = 'playerMain';

  /**
   * 접속자 - 정보 파라미터
   * user_id : 사용자 ID
   * mode : ingame(경기중)/recent(최근, default)/previous(이전)/today(오늘)/yesterday(어제)
   *        weekly(주간)/monthly(월간)/yearly(연간)
   */
  // if (!$rootScope.selectPlayerInfo) {
  //   $state.go('Service.main');
  // }
  // vm.userInfo = {
  //   user_id: $rootScope.selectPlayerInfo.user_id,
  //   mode: ''
  // };

  // 히트맵 탭모드 초기화
  vm.activeHeatmapTab = 'att';

  vm.playerTotalInfo = {}; //main/info 결과값을 모두 저장하는 변수
  let dateObj = new Date();
  let year = dateObj.getFullYear();
  let month = dateObj.getMonth() + 1;
  let date = dateObj.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }
  vm.startDate = `${year}-${month}-${date}`;
  vm.endDate = `${year}-${month}-${date + 1}`;

  $scope.$on('$viewContentLoaded', function (event) {
    // $('#startDate').each(function () {
    //   //   console.log($element);
    //   new Flatpickr(document.getElementById('startDate'), {
    //     minDate: "today",
    //     locale: Korean,
    //     dateFormat: 'Y-m-d',
    //     onChange: function (selectedDates, dateStr, instance) {
    //       vm.startDate = selectedDates;
    //     }
    //   });
    // }),
    //   $('#endDate').each(function () {
    //     new Flatpickr(this, {
    //       minDate: "today",
    //       locale: Korean,
    //       dateFormat: 'Y-m-d',
    //       onChange: function (selectedDates, dateStr, instance) {
    //         vm.endDate = selectedDates;
    //       }
    //     });
    //   });
  });

  /**
   * 선수의 종합적인 생체정보 조회
   */
  let chartPadding = {
    top: 0,
    bottom: 0,
    left: 30,
    right: 5
  };

  vm.metaData = {
    movements: null,
    locations: null,
    foots: null
  };
  vm.selectedSkill = null;
  vm.selectedLocation = null;
  vm.selectedFoot = null;
  // 훈련 정보 입력에 필요한 데이터 조회
  PlanService.getTrainingMeta().then(function (res) {
    // $scope.$apply(function () {
    // });

    // movements 에서 공격,수비 삭제
    _.remove(res.data.movements, function (movement) {
      return movement.name === '공격' || movement.name === '수비';
    });

    vm.metaData.movements = res.data.movements;
    vm.selectedSkill = vm.metaData.movements[0];

    //foots selectbox 셋팅
    let foots = [{
        id: 'all',
        name: '전체'
      },
      {
        id: 'right',
        name: 'Right foot'
      },
      {
        id: 'left',
        name: 'Left foot'
      }
    ];
    vm.metaData.foots = foots;
    vm.selectedFoot = vm.metaData.foots[0];

  });

  //경기장 위치 데이터 조회
  AnalysisService.getLocationList().then(function (res) {
    // $scope.$apply(function () {
    // });
    vm.metaData.locations = res.data.data;
    vm.metaData.locations.unshift({
      id: 0,
      name: '전체'
    });
    vm.selectedLocation = vm.metaData.locations[0];
  });

  vm.getPlayerBiometricInfo = function (mode, from, to, force) {

    var data = {
      mode: mode || 'recent',
      user_id: $stateParams.user_id
    }

    if (mode == 'user') {
      if (!from || !to) {
        toastr.error('시작일과 종료일을 선택해주십시오');
        return;
      }

      data.from = vm.from.replace(/\./g, '');
      data.to = vm.to.replace(/\./g, '');

      vm.showSearchDropdown = false;
      vm.showCustomPeriod = false;
    }

    // $('.loading').show();


    // // if (mode == 'user') {
    // //   data.from = vm.startDate.replace(/./g, '');
    // //   data.to = vm.endDate.replace(/./g, '');
    // // }



    // data.user_id = $stateParams.user_id;


    PlayerService.getPlayerBiometricInfo(data).then(
      function (res) {
        vm.playerTotalInfo = res.data;

        vm.playerTotalInfo.acceleration = vm.playerTotalInfo.velocity;

        setMainPagePlayerInfo();
        $scope.$watchGroup(['playerMain.selectedSkill', 'playerMain.selectedLocation', 'playerMain.selectedFoot'], function (newVal, oldVal) {
          if (newVal[0] || newVal[1] || newVal[2]) {
            vm.setMovementsInfo(newVal);
          }
        });
        vm.playerSkillData = res.data;
        let skillKeyName = 'skill';
        let targetId = '#player-skill-main-chart';

        $('.loading').hide();

      },
      function (err) {
        console.log('getPlayerBiometricInfo err : ', err)
      }
    ).catch(function (err) {
      console.log('ERR', err)
    });

  };

  let liquidGaugeSize = {
    width: '90px',
    height: '90px'
  };

  /**
   * 심박수 선택값 세팅
   */
  let heartbeatMainChart;
  vm.setHeartbeatInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.heartbeat = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? 'bpm' : ((type == 'recovery') ? '%' : '초');
    let value = vm.playerTotalInfo.heartbeat[0][type];
    // let value = '70';

    console.log('type, subType, value', type, subType, value)

    let heartbeatKeyName = 'heartbeat';
    let targetId = '#player-heartbeat-main-chart';
    if (type == 'reach' || type == 'recovery' || type == 'stable') {
      $scope.heartbeatSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.heartbeat[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (heartbeatMainChart.type == 'liquid') {
        heartbeatMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!heartbeatMainChart) {
        heartbeatMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        heartbeatMainChart.diameter(90).value(chartValue).render();
        heartbeatMainChart['type'] = 'raidal';
      } else {
        heartbeatMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      let max = 220 - 38;

      if (!heartbeatMainChart || heartbeatMainChart.type == 'raidal') {
        heartbeatMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart

      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'heartbeat-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      let dataValue = (value / max) * 100;
      console.log('dataValue', dataValue)
      if (!heartbeatMainChart) {
        heartbeatMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        heartbeatMainChart['type'] = 'liquid';
      } else {
        heartbeatMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '심박수',
      value,
      unit
    }
    vm.playerHeartbeatData = data;

    //line chart
    let heartbeatColumnData = [heartbeatKeyName]
    let heartbeatData = vm.playerTotalInfo.heartbeat[0].data;
    for (let i = 0; i < heartbeatData.length; i++) {
      heartbeatColumnData.push(heartbeatData[i].value);
    }

    let heartRateType = {};
    heartRateType[heartbeatKeyName] = 'area-spline';

    let heartbeatChartOptions = {
      targetId: '#player-heartbeat-line-chart',
      padding: chartPadding,
      columnData: heartbeatColumnData,
      type: heartRateType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //heart-rate line chart
    let heartbeatOptions = ChartGeneratorService.setLineChartOptions(heartbeatChartOptions);
    ChartGeneratorService.generateLineChart(heartbeatOptions)
  };

  /**
   * Street 선택값 세팅
   */
  let distanceMainChart;
  let distanceChartType;
  vm.setDistanceInfo = function (type, subType, deviceValue) {
    //type : max(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.distance = type;
    let value = vm.playerTotalInfo.distance[0][type];

    if (deviceValue) {
      value = deviceValue;
    }

    let distanceKeyName = 'distance';
    let targetId = '#player-distance-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.distanceSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.distance[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (distanceChartType == 'gauge') {
        distanceMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!distanceMainChart) {
        distanceMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        distanceMainChart.diameter(90).value(chartValue).render();
        distanceChartType = 'raidal';
      } else {
        distanceMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!distanceMainChart || distanceChartType == 'raidal') {
        distanceMainChart = null;
        $(targetId).html('');
      }

      if (!distanceMainChart) {
        let configuration = {
          size: 165,
          clipWidth: 158,
          clipHeight: 100,
          ringWidth: 30,
          maxValue: 60,
          transitionMs: 4000,
        }
        distanceMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
        distanceMainChart.render();
        distanceChartType = 'gauge';
      }
      distanceMainChart.update(value);
    }

    let data = {
      title: 'Street',
      value: value,
      unit: 'km'
    }
    vm.playerDistanceData = data

    //line chart
    let distanceColumnData = [distanceKeyName]
    let distanceData = vm.playerTotalInfo.distance[0].data;
    for (let i = 0; i < distanceData.length; i++) {
      distanceColumnData.push(distanceData[i].value);
    }

    let distanceType = {};
    distanceType[distanceKeyName] = 'spline';

    let distanceChartOptions = {
      targetId: '#player-distance-chart',
      padding: chartPadding,
      columnData: distanceColumnData,
      type: distanceType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-distance line chart
    let distanceOptions = ChartGeneratorService.setLineChartOptions(distanceChartOptions);
    ChartGeneratorService.generateLineChart(distanceOptions);
  };

  /**
   * 부상 선택값 세팅
   */
  vm.setInjuryInfo = function (type) {
    //type : norm(정상),recovery(회복),cure(치료),operation(수술),current(현재)
    console.log('vm.playerTotalInfo', vm.playerTotalInfo)
    $scope.injury = type;
    let data = {
      title: vm.playerTotalInfo.injury[0][type].status,
      value: vm.playerTotalInfo.injury[0][type].day,
      unit: 'day',
      cure_start_date: vm.playerTotalInfo.injury[0].cure_start_date && vm.playerTotalInfo.injury[0].cure_start_date.replace(/-/g, '.'),
      cure_end_date: vm.playerTotalInfo.injury[0].cure_end_date && vm.playerTotalInfo.injury[0].cure_end_date.replace(/-/g, '.'),
      oper_start_date: vm.playerTotalInfo.injury[0].oper_start_date && vm.playerTotalInfo.injury[0].oper_start_date.replace(/-/g, '.'),
      oper_end_date: vm.playerTotalInfo.injury[0].oper_end_date && vm.playerTotalInfo.injury[0].oper_end_date.replace(/-/g, '.')
    };
    vm.playerinjuryData = data;

    console.log('setInjuryInfo', data, type)

    let player_injury = vm.playerTotalInfo.injury[0].part + ' ' + vm.playerTotalInfo.injury[0].category;
    let injurylabel = d3.select('#player-injury-label-svg')
      .append('g')
      .attr('transform', 'translate(150, 30)').append('text');
    injurylabel.html(''); //remove existant text

    if (vm.playerTotalInfo.injury[0][type].status !== '정상') {
      injurylabel.insert('tspan').text(player_injury).attr('class', 'heat-title-label');
    }
  };

  /**
   * 산소 선택값 세팅
   */
  let oxygenMainChart;
  vm.setOxygenInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.oxygen = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current' || type == 'recovery') ? '%' : '초';
    let value = vm.playerTotalInfo.oxyzen[0][type];

    let oxygenKeyName = 'oxygenData';
    let targetId = '#player-oxygen-main-chart';
    if (type == 'reach' || type == 'recovery' || type == 'stable') {
      $scope.oxygenSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.oxyzen[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (oxygenMainChart.type == 'liquid') {
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!oxygenMainChart) {
        oxygenMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        oxygenMainChart.diameter(90).value(value).render();
        oxygenMainChart['type'] = 'raidal';
      } else {
        oxygenMainChart.diameter(90).value(value).render();
      }
    } else {
      if (!oxygenMainChart || oxygenMainChart.type == 'raidal') {
        oxygenMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'oxygen-liquid';
      options.circleColor = '#3187c5';
      options.textColor = '#3187c5';
      options.waveColor = '#3187c5';
      options.size = liquidGaugeSize;
      if (!oxygenMainChart) {
        oxygenMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
        oxygenMainChart['type'] = 'liquid';
      } else {
        oxygenMainChart.update(value);
      }
    }
    let data = {
      title: 'Sp02',
      value,
      unit
    };
    vm.playerOxygenData = data;

    //line chart
    let oxygenColumnData = [oxygenKeyName]
    let oxyzenData = vm.playerTotalInfo.oxyzen[0].data;
    for (let i = 0; i < oxyzenData.length; i++) {
      oxygenColumnData.push(oxyzenData[i].value);
    }

    let oxygenType = {};
    oxygenType[oxygenKeyName] = 'spline';

    let oxygenChartOptions = {
      targetId: '#player-oxygen-line-chart',
      padding: chartPadding,
      columnData: oxygenColumnData,
      type: oxygenType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };
    //player-oxygen line chart
    let oxygenOptions = ChartGeneratorService.setLineChartOptions(oxygenChartOptions);
    ChartGeneratorService.generateLineChart(oxygenOptions);
  };

  /**
   * speed 선택값 세팅
   */
  let velocityMainChart;
  let velocityChartType;
  vm.setVelocityInfo = function (type, subType, deviceValue) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    //   vm.playerTotalInfo.velocity[0].current = 15;
    //   vm.playerTotalInfo.velocity[0].target = 30;
    //   vm.playerTotalInfo.velocity[0].max = 25;
    //   vm.playerTotalInfo.velocity[0].reach = 45;
    //   vm.playerTotalInfo.velocity[0].average = 20;
    $scope.velocity = type;
    let value = vm.playerTotalInfo.velocity[0][type];

    if (deviceValue) {
      value = deviceValue;
    }

    let velocityKeyName = 'velocity';
    let targetId = '#player-velocity-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.velocitySubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.velocity[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (velocityChartType == 'gauge') {
        velocityMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!velocityMainChart) {
        velocityMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        velocityMainChart.diameter(90).value(chartValue).render();
        velocityChartType = 'raidal';
      } else {
        velocityMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!velocityMainChart || velocityChartType == 'raidal') {
        velocityMainChart = null;
        $(targetId).html('');
      }

      if (!velocityMainChart) {
        let configuration = {
          size: 165,
          clipWidth: 158,
          clipHeight: 100,
          ringWidth: 30,
          maxValue: 60,
          transitionMs: 4000,
        }
        velocityMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
        velocityMainChart.render();
        velocityChartType = 'gauge';
      }
      velocityMainChart.update(value);
    }
    let data = {
      title: 'speed',
      value: value,
      unit: 'm/s'
    };
    vm.playerVelocityData = data;

    //line chart
    let veleocityColumnData = [velocityKeyName];
    let velocityData = vm.playerTotalInfo.velocity[0].data;
    for (let i = 0; i < velocityData.length; i++) {
      veleocityColumnData.push(velocityData[i].value);
    }

    let velocityType = {};
    velocityType[velocityKeyName] = 'spline'

    let velocityChartOptions = {
      targetId: '#player-velocity-line-chart',
      padding: chartPadding,
      columnData: veleocityColumnData,
      type: velocityType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-velocity line chart
    let velocityOptions = ChartGeneratorService.setLineChartOptions(velocityChartOptions);
    ChartGeneratorService.generateLineChart(velocityOptions);
  };

  /**
   * acceleration 선택값 세팅
   */
  let accelerationMainChart;
  let accelerationChartType;
  vm.setAccelerationInfo = function (type, subType, deviceValue) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    //   vm.playerTotalInfo.acceleration[0].current = 15;
    //   vm.playerTotalInfo.acceleration[0].target = 30;
    //   vm.playerTotalInfo.acceleration[0].max = 25;
    //   vm.playerTotalInfo.acceleration[0].reach = 45;
    //   vm.playerTotalInfo.acceleration[0].average = 20;
    $scope.acceleration = type;
    let value = vm.playerTotalInfo.acceleration[0][type];

    if (deviceValue) {
      value = deviceValue;
    }

    let accelerationKeyName = 'acceleration';
    let targetId = '#player-acceleration-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.accelerationSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.acceleration[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (accelerationChartType == 'gauge') {
        accelerationMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!accelerationMainChart) {
        accelerationMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        accelerationMainChart.diameter(90).value(chartValue).render();
        accelerationChartType = 'raidal';
      } else {
        accelerationMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!accelerationMainChart || accelerationChartType == 'raidal') {
        accelerationMainChart = null;
        $(targetId).html('');
      }

      if (!accelerationMainChart) {
        let configuration = {
          size: 165,
          clipWidth: 158,
          clipHeight: 100,
          ringWidth: 30,
          maxValue: 60,
          transitionMs: 4000,
        }
        accelerationMainChart = ChartGeneratorService.createCircularGauge(targetId, configuration)
        accelerationMainChart.render();
        accelerationChartType = 'gauge';
      }
      accelerationMainChart.update(value);
    }
    let data = {
      title: 'acceleration',
      value: value,
      unit: 'm/s'
    };
    vm.playerAccelerationData = data;

    //line chart
    let veleocityColumnData = [accelerationKeyName];
    let accelerationData = vm.playerTotalInfo.acceleration[0].data;
    for (let i = 0; i < accelerationData.length; i++) {
      veleocityColumnData.push(accelerationData[i].value);
    }

    let accelerationType = {};
    accelerationType[accelerationKeyName] = 'spline'

    let accelerationChartOptions = {
      targetId: '#player-acceleration-line-chart',
      padding: chartPadding,
      columnData: veleocityColumnData,
      type: accelerationType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-acceleration line chart
    let accelerationOptions = ChartGeneratorService.setLineChartOptions(accelerationChartOptions);
    ChartGeneratorService.generateLineChart(accelerationOptions);
  };

  /**
   * 칼로리섭취 선택값 세팅
   */
  let caloryGetMainChart;
  vm.setCaloryGetInfo = function (type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryget = type;
    let value = vm.playerTotalInfo.calrorie_get[0][type];

    let caloryKeyName = 'calory';
    let targetId = '#player-calory-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.calorygetSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_get[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (caloryGetMainChart.type == 'liquid') {
        caloryGetMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!caloryGetMainChart) {
        caloryGetMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        caloryGetMainChart.diameter(90).value(chartValue).render();
        caloryGetMainChart['type'] = 'raidal';
      } else {
        caloryGetMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      let max = vm.playerTotalInfo.calrorie_get[0].max;
      let dataValue;
      if (max == 0) {
        max = 100;
        dataValue = 0;
      } else {
        dataValue = (value / max) * 100;
      }

      if (!caloryGetMainChart || caloryGetMainChart.type == 'raidal') {
        caloryGetMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-calory-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if (!caloryGetMainChart) {
        caloryGetMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        caloryGetMainChart['type'] = 'liquid';
      } else {
        caloryGetMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '칼로리섭취',
      value: number_format(value),
      unit: 'kcal'
    };
    vm.playerCaloryData = data;

    //line chart
    let caloryColumnData = [caloryKeyName];
    let caloryData = vm.playerTotalInfo.calrorie_get[0].data;
    for (let i = 0; i < caloryData.length; i++) {
      caloryColumnData.push(caloryData[i].value);
    }

    let caloryType = {};
    caloryType[caloryKeyName] = 'spline';

    let caloryChartOptions = {
      targetId: '#player-calory-line-chart',
      padding: chartPadding,
      columnData: caloryColumnData,
      type: caloryType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryOptions = ChartGeneratorService.setLineChartOptions(caloryChartOptions);
    ChartGeneratorService.generateLineChart(caloryOptions);
  };

  /**
   * 젖산 선택값 세팅
   */
  let lacticMainChart;
  vm.setLacticInfo = function (type, subType) {
    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.lactic = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? 'mg/dℓ' : ((type == 'recovery') ? '%' : '초');
    let value = vm.playerTotalInfo.lactic[0][type];

    let lacticKeyName = 'lactic';
    let targetId = '#player-lactic-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'recovery') {
      $scope.lacticSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.lactic[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (lacticMainChart.type == 'liquid') {
        lacticMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!lacticMainChart) {
        lacticMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        lacticMainChart.diameter(90).value(chartValue).render();
        lacticMainChart['type'] = 'raidal';
      } else {
        lacticMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      let max = vm.playerTotalInfo.lactic[0].max;
      if (max == 0) {
        max = 10;
      }

      if (!lacticMainChart || lacticMainChart.type == 'raidal') {
        lacticMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'lactic-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if (!lacticMainChart) {
        lacticMainChart = ChartGeneratorService.loadLiquidFillGauge(value, options);
        lacticMainChart['type'] = 'liquid';
      } else {
        lacticMainChart.update(value);
      }
    }

    let data = {
      title: '젖산',
      value,
      unit
    };
    vm.playerLacticData = data;

    //line chart
    let lacticColumnData = [lacticKeyName];
    let lacticData = vm.playerTotalInfo.lactic[0].data;
    for (let i = 0; i < lacticData.length; i++) {
      lacticColumnData.push(lacticData[i].value);
    }

    let lacticType = {};
    lacticType[lacticKeyName] = 'spline';

    let lacticChartOptions = {
      targetId: '#player-lactic-line-chart',
      padding: chartPadding,
      columnData: lacticColumnData,
      type: lacticType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-lactic line chart
    let lacticOptions = ChartGeneratorService.setLineChartOptions(lacticChartOptions);
    ChartGeneratorService.generateLineChart(lacticOptions);
  };

  /**
   * 체중 선택값 세팅
   */
  let weightMainChart;
  let weightChartType;
  vm.setWeightInfo = function (type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.weight = type;
    let value = vm.playerTotalInfo.weight[0][type];

    let weightKeyName = 'weight';
    let targetId = 'player-weight-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.weightSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.lactic[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (weightChartType == 'gauge') {
        weightMainChart = null;
        $('#player-weight-main-chart').html('');
      }
      //radial progress bar chart
      if (!weightMainChart) {
        weightMainChart = ChartGeneratorService.updateRadialProgress('#player-weight-main-chart');
        weightMainChart.diameter(90).value(chartValue).render();
        weightChartType = 'raidal';
      } else {
        weightMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!weightMainChart || weightChartType == 'raidal') {
        weightMainChart = null;
        $('#player-weight-main-chart').html('');
      }
      /* weight gauges chart */
      if (!weightMainChart) {
        let size = 100;
        weightMainChart = ChartGeneratorService.createGaugeChart(targetId, weightKeyName, size);
        weightChartType = 'gauge';
      }
      ChartGeneratorService.updateGaugeChart(value, weightMainChart, targetId);
    }

    let data = {
      title: '체중',
      value,
      unit: 'kg'
    };
    vm.playerWeightData = data;

    //line chart
    let weightColumnData = [weightKeyName];
    let weightData = vm.playerTotalInfo.weight[0].data;
    for (let i = 0; i < weightData.length; i++) {
      weightColumnData.push(weightData[i].value);
    }

    let weightType = {};
    weightType[weightKeyName] = 'spline';
    let weightChartOptions = {
      targetId: '#player-weight-line-chart',
      padding: chartPadding,
      columnData: weightColumnData,
      type: weightType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-weight line chart
    let weightOptions = ChartGeneratorService.setLineChartOptions(weightChartOptions);
    ChartGeneratorService.generateLineChart(weightOptions);
  };

  /**
   * 체온 선택값 세팅
   */
  let temperatureMainChart;
  let temperatureChartType;
  vm.setTemperatureInfo = function (type, subType) {

    //type : max(최대),stable(안정),recovery(회복),reach(도달),current(현재)
    $scope.temperature = type;
    let unit = (type == 'max' || type == 'stable' || type == 'current') ? '℃' : ((type == 'recovery') ? '%' : '초');
    let value = vm.playerTotalInfo.temperature[0][type];

    let temperatureKeyName = 'temperature';
    let targetId = '#player-temperature-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'recovery') {
      $scope.temperatureSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.temperature[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (temperatureChartType == 'meter') {
        temperatureMainChart = null;
        $(targetId).html('');
      }
      //radial progress bar chart
      if (!temperatureMainChart) {
        temperatureMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        temperatureMainChart.diameter(90).value(chartValue).render();
        temperatureChartType = 'raidal';
      } else {
        temperatureMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!temperatureMainChart || temperatureChartType == 'raidal') {
        temperatureMainChart = null;
        $(targetId).html('');
      }

      let thermometerOptions = {
        targetId: targetId,
        svg_height: 100,
        svg_width: 100,
        svg_style: 'padding-top:3px;',
        max_temp: 44,
        min_temp: 32,
        current_temp: value,
        topY: 5,
        bulb_radius: 12,
        tube_width: 13,
        tube_border_width: 1,
      };
      ChartGeneratorService.createThermometer(thermometerOptions);
      temperatureChartType = 'meter';
    }

    let data = {
      title: '체온',
      value,
      unit
    };
    vm.playerTemperatureData = data;

    //line chart
    let temperatureColumnData = [temperatureKeyName];
    let temperatureData = vm.playerTotalInfo.temperature[0].data;
    for (let i = 0; i < temperatureData.length; i++) {
      temperatureColumnData.push(temperatureData[i].value);
    }

    let temperatureType = {};
    temperatureType[temperatureKeyName] = 'spline';

    let temperatureChartOptions = {
      targetId: '#player-temperature-line-chart',
      padding: chartPadding,
      columnData: temperatureColumnData,
      type: temperatureType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-temperature line chart
    let temperatureOptions = ChartGeneratorService.setLineChartOptions(temperatureChartOptions);
    ChartGeneratorService.generateLineChart(temperatureOptions);
  }

  /**
   * 수면 선택값 세팅
   */
  let sleepMainChart;
  vm.setSleepInfo = function (type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.sleep = type;
    let max = vm.playerTotalInfo.sleep[0].max.hour * 60 + vm.playerTotalInfo.sleep[0].max.minute;
    if (max == 0) {
      max = 1440;
    }
    max = 1440
    let hour = vm.playerTotalInfo.sleep[0][type].hour;
    let minute = vm.playerTotalInfo.sleep[0][type].minute;
    let value = ((hour * 60) + minute) / max * 100;

    let sleepKeyName = 'sleep';
    let targetId = '#player-sleep-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.sleepSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.sleep[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (sleepMainChart.type == 'liquid') {
        sleepMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!sleepMainChart) {
        sleepMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        sleepMainChart.diameter(90).value(chartValue).render();
        sleepMainChart['type'] = 'raidal';
      } else {
        sleepMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!sleepMainChart || sleepMainChart.type == 'raidal') {
        sleepMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'sleep-liquid';
      options.circleColor = '#27f72d';
      options.textColor = '#27f72d';
      options.waveColor = '#27f72d';
      options.size = liquidGaugeSize;
      if (!sleepMainChart) {
        sleepMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(value), options);
        sleepMainChart['type'] = 'liquid';
      } else {
        sleepMainChart.update(Math.round(value));
      }
    }

    let data = {
      title: '수면',
      hour,
      hourUnit: '시간',
      minute,
      minuteUnit: '분'
    }
    vm.playerSleepData = data;

    //line chart
    let sleepColumnData = [sleepKeyName];
    let sleepeData = vm.playerTotalInfo.sleep[0].data;
    for (let i = 0; i < sleepeData.length; i++) {
      sleepColumnData.push(sleepeData[i].value);
    }

    let sleepType = {};
    sleepType[sleepKeyName] = 'spline';

    let sleepChartOptions = {
      targetId: '#player-sleep-line-chart',
      padding: chartPadding,
      columnData: sleepColumnData,
      type: sleepType,
      color: '#27f72d',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //sleep line chart
    let sleepOptions = ChartGeneratorService.setLineChartOptions(sleepChartOptions);
    ChartGeneratorService.generateLineChart(sleepOptions);
  }

  /**
   * 칼로리섭취 선택값 세팅
   */
  let caloryBurnMainChart;
  vm.setCaloryBurnInfo = function (type, subType) {
    //type : max(최대),stable(안정),reach(도달),average(평균),current(현재)
    $scope.caloryburn = type;
    let value = vm.playerTotalInfo.calrorie_burned[0][type];

    let caloryBurnKeyName = 'caloryburn';
    let targetId = '#player-burn-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.caloryburnSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.calrorie_burned[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (caloryBurnMainChart.type == 'liquid') {
        caloryBurnMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!caloryBurnMainChart) {
        caloryBurnMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        caloryBurnMainChart.diameter(90).value(chartValue).render();
        caloryBurnMainChart['type'] = 'raidal';
      } else {
        caloryBurnMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      let max = vm.playerTotalInfo.calrorie_burned[0].max;
      let dataValue;
      if (max == 0) {
        max = 100;
        dataValue = 0;
      } else {
        dataValue = (value / max) * 100;
      }

      if (!caloryBurnMainChart || caloryBurnMainChart.type == 'raidal') {
        caloryBurnMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'calory-burn-liquid';
      options.circleColor = '#c833c8';
      options.textColor = '#c833c8';
      options.size = liquidGaugeSize;
      if (!caloryBurnMainChart) {
        caloryBurnMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        caloryBurnMainChart['type'] = 'liquid';
      } else {
        caloryBurnMainChart.update(Math.round(dataValue));
      }
    }
    let data = {
      title: '칼로리소모',
      value: number_format(value),
      unit: 'kcal'
    };
    vm.playerBurnData = data;

    //line chart
    let caloryBurnColumnData = [caloryBurnKeyName];
    let caloryBurnData = vm.playerTotalInfo.calrorie_burned[0].data;
    for (let i = 0; i < caloryBurnData.length; i++) {
      caloryBurnColumnData.push(caloryBurnData[i].value);
    }

    let caloryBurnType = {};
    caloryBurnType[caloryBurnKeyName] = 'spline';

    let caloryBurnChartOptions = {
      targetId: '#player-burn-line-chart',
      padding: chartPadding,
      columnData: caloryBurnColumnData,
      type: caloryBurnType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-calory line chart
    let caloryBurnOptions = ChartGeneratorService.setLineChartOptions(caloryBurnChartOptions);
    ChartGeneratorService.generateLineChart(caloryBurnOptions);
  }


  /**
   * 수분 선택값 세팅
   */
  let waterMainChart;
  vm.setWaterInfo = function (type, subType) {
    //type : target(목표),stable(안정),reach(도달),average(평균),current(현재)
    $scope.water = type;

    let value = vm.playerTotalInfo.water[0][type];
    let max = vm.playerTotalInfo.water[0].max;
    if (max == 0) {
      max = 100;
    }

    let waterKeyName = 'water';
    let targetId = '#player-water-main-chart';
    if (type == 'reach' || type == 'stable' || type == 'average') {
      $scope.waterSubType = subType;
      let chartValue = 0;
      if (type == 'reach') { //도달인 경우 최대/안정 대비 도달 비율
        let subValue = vm.playerTotalInfo.water[0][subType];
        chartValue = (value / subValue) * 100;
      } else { //
        chartValue = value;
      }

      if (Number.isNaN(chartValue)) {
        chartValue = 0;
      }

      if (waterMainChart.type == 'liquid') {
        waterMainChart = null;
        $(targetId).html('');
      }

      //radial progress bar chart
      if (!waterMainChart) {
        waterMainChart = ChartGeneratorService.updateRadialProgress(targetId);
        waterMainChart.diameter(90).value(chartValue).render();
        waterMainChart['type'] = 'raidal';
      } else {
        waterMainChart.diameter(90).value(chartValue).render();
      }
    } else {
      if (!waterMainChart || waterMainChart.type == 'raidal') {
        waterMainChart = null;
        $(targetId).html('');
      }

      //liquid gauge chart
      let options = ChartGeneratorService.getLiquidGaugeOptions();
      options.targetId = targetId;
      options.svgId = 'water-liquid';
      options.circleColor = '#3187c5';
      options.textColor = '#3187c5';
      options.waveColor = '#3187c5';
      options.size = liquidGaugeSize;
      let dataValue = value / max * 100;
      if (!waterMainChart) {
        waterMainChart = ChartGeneratorService.loadLiquidFillGauge(Math.round(dataValue), options);
        waterMainChart['type'] = 'liquid';
      } else {
        waterMainChart.update(Math.round(dataValue));
      }
    }

    let data = {
      title: '수분',
      value: number_format(value),
      unit: 'ml'
    };
    vm.playerWaterData = data;

    //line chart
    let waterColumnData = [waterKeyName];
    let waterData = vm.playerTotalInfo.water[0].data;
    for (let i = 0; i < waterData.length; i++) {
      waterColumnData.push(waterData[i].value);
    }

    let waterType = {};
    waterType[waterKeyName] = 'spline';

    let waterChartOptions = {
      targetId: '#player-water-line-chart',
      padding: chartPadding,
      columnData: waterColumnData,
      type: waterType,
      color: '#3187c5',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //heart-rate line chart
    let waterOptions = ChartGeneratorService.setLineChartOptions(waterChartOptions);
    ChartGeneratorService.generateLineChart(waterOptions)
  }


  // 히트맵 탭 클릭
  vm.changeHeatmapTab = function (mode) {
    vm.activeHeatmapTab = mode;
    vm.setMovementsInfo([vm.selectedSkill, vm.selectedLocation, vm.selectedFoot]);
  };


  let locationNum = 0;
  let heatmapInstance;
  vm.setMovementsInfo = function (selectedData) {
    return;

    // console.log('vm.setMovementsInfo ...... return');
    // return;
    // console.log('vm.playerTotalInfo', vm.playerTotalInfo);
    // console.log('selectedData ...........', selectedData);
    let skillIdx = $('#movement option').index($('#movement option:selected'));
    console.log('skillIdx, vm.playerTotalInfo.movements ... ', skillIdx, vm.playerTotalInfo.movements)
    let data = {
      name: vm.playerTotalInfo.movements[skillIdx].name,
      total: vm.playerTotalInfo.movements[skillIdx].total,
      success: vm.playerTotalInfo.movements[skillIdx].suc,
      right: vm.playerTotalInfo.movements[skillIdx].right,
      left: vm.playerTotalInfo.movements[skillIdx].left
    };
    vm.playerSkillData = data;
    let skillKeyName = 'skill';
    let targetId = '#player-skill-main-chart';

    $(targetId).html('');
    let successPer = (data.success / data.total) * 100;
    if (Number.isNaN(successPer)) {
      successPer = 0; //임시 값 제거
    }
    let rightPer = (data.right / (data.right + data.left)) * 100;
    if (Number.isNaN(rightPer)) {
      rightPer = 0; //임시 값 제거
    }

    let dataset = [{
        data: [{
            title: '성공',
            count: successPer //성공
          },
          {
            title: '발',
            count: rightPer //Right foot
          }
        ]
      },
      {
        data: [{
            title: '성공',
            count: 100 - successPer //실패
          },
          {
            title: '발',
            count: successPer - rightPer //Left foot
          }
        ]
      }
    ];
    console.log('dataset', dataset);
    ChartGeneratorService.createStackedBarChartHorizAnalysis(targetId, dataset);

    let locData = {
      name: selectedData[1].name
    };
    vm.playerLocationData = locData;
    let locationKeyName = 'location';
    let locations = vm.playerTotalInfo.locations;

    var points = [];

    // heatmap 크기 설정
    var heatmapContainerParent = $('.heatmap').closest('.w3-display-container'),
      heatmapWidth = heatmapContainerParent.width(),
      heatmapHeight = heatmapContainerParent.height();
    $('.heatmap')
      .width(heatmapWidth)
      .height(heatmapHeight);
    var heatmapRadius = 30;

    if (selectedData[1].id) {
      var targetObj = EventAnalysisService.getPosition(heatmapWidth, heatmapHeight, selectedData[1].abbr);
      targetObj.radius = heatmapRadius;
      var targetLoc = _.find(locations, {
        abbr: selectedData[1].abbr
      });

      if (vm.activeHeatmapTab == 'suc') {
        targetObj['value'] = targetLoc.top_suc + targetLoc.right_suc + targetLoc.left_suc + targetLoc.bottom_suc;
      } else {
        targetObj['value'] = targetLoc.top_att + targetLoc.right_att + targetLoc.left_att + targetLoc.bottom_att;
      }

      // 임시데이터 삽입
      // targetObj['value'] = Math.floor((Math.random() * 100) + 1);
      // points.push(targetObj);
    } else {
      _.forEach(locations, function (o) {
        var targetObj = EventAnalysisService.getPosition(heatmapWidth, heatmapHeight, o.abbr);
        targetObj.radius = heatmapRadius;
        // console.log('targetObj 000....', targetObj);
        if (targetObj) {
          if (vm.activeHeatmapTab == 'suc') {
            targetObj['value'] = o.top_suc + o.right_suc + o.left_suc + o.bottom_suc;
          } else {
            targetObj['value'] = o.top_att + o.right_att + o.left_att + o.bottom_att;
          }

          // 임시데이터 삽입
          // if (targetObj['value'] <= 0) {
          //   targetObj['value'] = Math.floor((Math.random() * 100) + 1);
          // }
          // console.log('targetObj 111....', targetObj);
          // points.push(targetObj);
        }
      });
    }

    // console.log('locatons > ', locations);

    //minimal heatmap instance configuration
    if (!heatmapInstance) {
      heatmapInstance = h337.create({
        container: document.querySelector('.heatmap')
      });
    };

    //generate data
    //   let points = [{x:80, y: 80, value:95, radius:20},{x:40, y: 80, value:45, radius:20}
    //                 ,{x:60, y: 90, value:70, radius:20},{x:80, y: 90, value:45, radius:20}
    //                 ,{x:80, y: 100, value:59, radius:20},{x:80, y: 100, value:88, radius:20}
    //                 ,{x:80, y: 110, value:59, radius:20},{x:80, y: 110, value:88, radius:20}
    //                  ,{x:100, y: 90, value:70, radius:20},{x:110, y: 90, value:45, radius:20}
    //                 ,{x:120, y: 100, value:59, radius:20},{x:130, y: 100, value:88, radius:20}
    //                 ,{x:140, y: 110, value:59, radius:20},{x:150, y: 110, value:88, radius:20}];
    //   let max = 0;
    //   let width = 200;
    //   let height = 200

    console.log('points......', points);

    let locationData = {
      max: 100,
      // width : 100,
      // height : 200,
      data: points
    };
    heatmapInstance.removeData();
    heatmapInstance.setData(locationData);

    //line chart
    let skillColumnData = [skillKeyName];
    let skillData = vm.playerTotalInfo.lactic[0].data;
    for (let i = 0; i < skillData.length; i++) {
      skillColumnData.push(skillData[i].value);
    }

    let skillType = {};
    skillType[skillKeyName] = 'spline';

    let skillChartOptions = {
      targetId: '#player-skill-line-chart',
      padding: chartPadding,
      columnData: skillColumnData,
      type: skillType,
      color: '#c833c8',
      height: 60,
      legendShow: false,
      grid: {},
      axis: {},
      pointShow: false,
      tooltipShow: false
    };

    //player-skill line chart
    let skillOptions = ChartGeneratorService.setLineChartOptions(skillChartOptions);
    ChartGeneratorService.generateLineChart(skillOptions);
  }

  /**
   * player-main 화면 선수(개인)정보 세팅
   */
  function setMainPagePlayerInfo() {
    // if (vm.userInfo.mode == 'recent') {
    if (true) {
      /**
       * 선수 포지션 표시
       */
      let positionClass = vm.playerTotalInfo.position;
      let backNumber = vm.playerTotalInfo.back_number;
      let playerName = vm.playerTotalInfo.name;
      let cssKey = 'margin-left';
      if (positionClass == 'FW-RWF' || positionClass == 'MF-RWM' || positionClass == 'MF-RM' || positionClass == 'DF-RWB' || positionClass == 'DF-RB') {
        cssKey = 'margin-right';
      }

      let positionHtmlElement = `<span style="position: absolute; ${cssKey}:-30px" class=${positionClass}><strong>${backNumber}</strong>${playerName}</span>`;
      $("#player-field-position").html(positionHtmlElement);

      /**
       * 기본정보 세팅
       * 경기일자/시간/명칭/상대팀명/경기장/날씨/습도/기온/바람
       * 고도/잔디/총경기/총전적/득점/실점/도움/경고/퇴장
       */
      if (vm.playerTotalInfo.game_info) {
        vm.playerGameInfo = vm.playerTotalInfo.game_info[0];
      }
      vm.playerRecordInfo = vm.playerTotalInfo.game_record[0];
    }
    /**
     * 선수생체 정보 세팅
     * 심박수/Street/부상/산소포화도/speed/칼로리섭취/젖산/체중/체온/수면/칼로리소모/수분
     */
    vm.setHeartbeatInfo('current'); //heartbeat
    vm.setVelocityInfo('current'); //velocity
    vm.setAccelerationInfo('current'); //acceleration
    vm.setInjuryInfo('current'); //injury
    vm.setOxygenInfo('current'); //Sp02
    vm.setCaloryBurnInfo('current'); //calory_burn
    vm.setCaloryGetInfo('current'); //caloryGet
    vm.setLacticInfo('current'); //lactic
    // vm.setMovementsInfo('current');        //movements
    vm.setWeightInfo('current'); //weight
    vm.setTemperatureInfo('current'); //temperature
    vm.setSleepInfo('current'); //sleep
    vm.setWaterInfo('current'); //water
    // vm.setLocationInfo('current');         //location
    vm.setDistanceInfo('current'); //distance

    vm.setStrategyChart1(); // 득점 예측
    vm.setStrategyChart2(); // 실점 예측
  }

  // /* 메인화면 선수 생체정보 데이터 및 차트 초기화 */
  // vm.getPlayerBiometricInfo('recent');



}

export default {
  name: 'PlayerDetailCtrl',
  fn: PlayerDetailCtrl
};
